function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "HomeMenu-icon-Message",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "mail-01",
  transform: "translate(16.000000, 18.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M48.986,28.501 C49.0111656,28.7142485 48.9765429,28.9302945 48.886,29.125 C48.7061207,29.8948675 48.3139372,30.5988576 47.754,31.157 L47.754,31.157 C46.9598717,31.9556953 45.8803007,32.4051567 44.754,32.406 L4.245,32.406 C2.27277911,32.3994425 0.562917213,31.0399927 0.112,29.12 C0.0195676503,28.9258777 -0.0151427128,28.709285 0.012,28.496 C-3.01867118e-08,28.384 -3.01867118e-08,28.268 -3.01867118e-08,28.156 L-3.01867118e-08,4.25 C-3.01867118e-08,3.15772462 0.4223636,2.10776068 1.179,1.32 L1.244,1.25 C2.0383166,0.451585095 3.11776564,0.00217447881 4.244,0.001 L44.755,0.001 C45.8804932,0.001 46.9598002,0.448512625 47.755,1.245 L47.755,1.245 C48.5514874,2.04019983 48.9990667,3.11950682 48.9990667,4.245 L48.9990667,28.151 C48.9996667,28.2676667 48.9953333,28.3843333 48.986,28.501 Z",
  id: "Trazado_417"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Trazado_418",
  fill: "#D2D9DB",
  points: "13.696 17.708 2.316 9.106 2.316 26.315"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.39,19.162 L27.062,23.948 C25.5542746,25.1101047 23.4527254,25.1101047 21.945,23.948 L15.611,19.162 L2.54,29.051 C2.63301732,29.2229766 2.74909025,29.3814414 2.885,29.522 C3.24646798,29.8852847 3.73752184,30.0899804 4.25,30.0910098 L44.76,30.0910098 C45.2720221,30.0926322 45.7634635,29.8895751 46.125,29.527 L46.125,29.527 C46.2648652,29.3898208 46.3813977,29.2307285 46.47,29.056 L33.39,19.162 Z",
  id: "Trazado_419",
  fill: "#E6EEF0"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Trazado_420",
  fill: "#D2D9DB",
  points: "46.684 9.106 35.309 17.706 46.684 26.313"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.316,6.202 L16.291,16.771 L16.333,16.804 L23.333,22.098 C24.0177967,22.6322372 24.9782033,22.6322372 25.663,22.098 L32.663,16.804 L32.705,16.771 L46.6840098,6.202 L46.6840098,4.245 C46.6856322,3.73297792 46.4825751,3.24153646 46.12,2.88 L46.12,2.88 C45.7563955,2.51440829 45.2616194,2.30951193 44.746,2.31099195 L4.246,2.31099195 C3.73352184,2.31201955 3.24246798,2.51671527 2.881,2.88 L2.834,2.927 C2.50000332,3.28479738 2.31509659,3.75654201 2.317,4.246 L2.316,6.202 Z",
  id: "Trazado_421",
  fill: "#FFFFFF"
})));
function SvgHomeMenuIconMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "69px",
    viewBox: "0 0 80 69",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "HomeMenu-icon-Message") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeMenuIconMessage);
export default __webpack_public_path__ + "static/media/HomeMenu-icon-Message.c118e0bf74d07c2b62b6aa58076adc75.svg";
export { ForwardRef as ReactComponent };